import './index.css'

import { debounce } from 'lodash'
import React from 'react'
import ReactDOM from 'react-dom'
import TagManager, { TagManagerArgs } from 'react-gtm-module'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'

import ExternalApp from './components/external/ExternalApp'
import { App } from './components/internal/internalapp.components'
import { saveStateToLocalStorage } from './redux/store/localStorage'
import { store } from './redux/store/store'
import { gtmId_DIC, gtmId_FIC, isDic } from './common/utils'
const tagManagerArgs: TagManagerArgs = {
  gtmId: isDic() ? gtmId_DIC : gtmId_FIC,
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
TagManager.initialize(tagManagerArgs)

//css loaded only outside the widget to embed HC in DIC or FIC
if (location.host.includes('help.') || location.host.includes('help-center.')) {
  require('./help-center.css')
}

store.subscribe(
  debounce(() => {
    saveStateToLocalStorage(
      store.getState().adminMode,
      store.getState().realm,
      store.getState().visualizationMode,
      store.getState().editor,
      store.getState().chat
    )
  }, 500)
)
ReactDOM.render(
  <>
    <App>
      <Router>
        <Provider store={store}>
          <ExternalApp />
        </Provider>
      </Router>
    </App>
  </>,
  document.getElementById('root')
)
